const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000',
  support: {
    phone: '+45 12 34 56 78 TODO',
    email: 'support@get-sails.dk',
  },
  termsUrl: 'https://get-sails.dk/terms',
  privacyUrl: 'https://get-sails.dk/privacy',
  segmentWriteKey: 'rK473DbZoiD6u8zYwzAJRIrf6TewYuYf',
  stripePublicKey:
    process.env.NODE_ENV === 'production'
      ? 'pk_live_51HywHqEyqPSxrDOgqI2Z31AM3VKjueAhhODkUZqLeVIMZiGRDoAJNU2QqZI7dmixR3qn3aFxjdcCOrccFlwBO2lc001iJxBmIO'
      : 'pk_test_51HywHqEyqPSxrDOga36SXev10WR7n0B8B9cXTvxrZPxrJ0rQj0WZfkuhosRm5Lz327kwLYEiIU7nivBSuOqvHxqf00HiAIARCA',
};

export default config;
